//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { SERVICES_MODULE_NAME } from './../../services/services.module'
import { PACKAGE_SERVICE_NAME, PackageService } from '../../services/package'
import {
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    SYSTEM_SERVICE_PROVIDER_NAME,
    SystemService,
    SystemServiceProvider,
    $STATE_SERVICE_PROVIDER_NAME
} from '../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

import { ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'

import { PackageController } from './packages.controller'
import { PackagesHelper } from './packages.helper'
import { COMPONENTS_MODULE_NAME, DETAILS_DIRECTIVE_NAME, } from './components'

//#region Asset Imports

import * as TEMPLATE from './packages.tpl.html'

//#endregion

// Consts

const CONTROLLER_NAME: string = 'PackagesController'
const MENU_INDEX = 10
const MODULE_NAME: string = 'simax.packages'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'PACKAGE_NAME'
const STATE_NAME: string = 'packages'
const STATE_URL: string = '/packages'

// Consts End


// Setup

const module = angular.module(
    MODULE_NAME,
    [
        commonModule,
        apiModule,
        SERVICES_MODULE_NAME,
        COMPONENTS_MODULE_NAME
    ])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'localDictionary',
    PACKAGE_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    (
        $scope: ScopeBaseGridsterGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        packageService: PackageService,
        systemService: SystemService,
        userSessionService: UserSessionService
    ) => new PackageController(
        $scope,
        $state,
        $timeout,
        api,
        localDictionary,
        packageService,
        systemService,
        userSessionService,
        PackagesHelper.REFERENCE_TYPE,
        PackagesHelper.SIMAX_MODULE_NAME
    )])

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Package_IdPackage',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.PACKAGE_LIST)
                && !loggedOperator.hasPermission(Activity.ORDER_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.PackageModule)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.PACKAGE),
                    'packages',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME